import { BaseJsonSchema, createSchemaByBasicTypes } from "../../helpers";

const PlacementPositions: BaseJsonSchema = {
  type: "object",
  properties: {
    top: createSchemaByBasicTypes("number"),
    right: createSchemaByBasicTypes("number"),
    bottom: createSchemaByBasicTypes("number"),
    left: createSchemaByBasicTypes("number"),
  },
};

export const IPublisher: BaseJsonSchema = {
  type: "object",
  properties: {
    navbarSelector: createSchemaByBasicTypes("string", null, {
      pattern: "^(\\.|#).+",
      description:
        "Query selector for the navbar element. Used to dynamically change the position of the player when it hits this navbar element.",
    }),
    customDomainStyles: {
      type: "object",
      description:
        "Used to override default fvp player styles. Available properties [articleElSelector, backgroundColor, backgroundColorRefElSelector, positionOverrides, cssOverrides]",
      properties: {
        articleElSelector: createSchemaByBasicTypes("string", null, {
          description:
            "Query selector id for the article element. Used to dynamically change bg color of player when it hits this article element.",
        }),
        backgroundColor: createSchemaByBasicTypes("string", null, {
          description:
            "Background color for the player. Used to override the default styles.",
        }),
        backgroundColorRefElSelector: createSchemaByBasicTypes("string", null, {
          description:
            "Query selector for the background color reference element. Used to override the default styles based on the background color of the reference element.",
        }),
        positionOverrides: {
          type: "object",
          description:
            "Used to override the default position of the player. Available properties [desktop, mobile]",
          properties: {
            desktop: {
              type: "object",
              description:
                "Available position overrides [top, bottom, left, right]",
              properties: {
                top: createSchemaByBasicTypes("number"),
                bottom: createSchemaByBasicTypes("number"),
                left: createSchemaByBasicTypes("number"),
                right: createSchemaByBasicTypes("number"),
              },
            },
            mobile: {
              type: "object",
              description: "Available position overrides [top, bottom]",
              properties: {
                top: createSchemaByBasicTypes("number"),
                bottom: createSchemaByBasicTypes("number"),
              },
            },
          },
        },
        cssOverrides: createSchemaByBasicTypes("string", null, {
          description: "Used to override the default class names.",
        }),
        playerPlacementPadding: {
          type: "object",
          description:
            "Used to add padding to the player based on its placement. Available properties [desktop, mobile]",
          properties: {
            desktop: {
              type: "object",
              description:
                "Add padding specific to desktop player placements. Available properties [topLeft, topRight, bottomLeft, bottomRight]",
              properties: {
                topLeft: PlacementPositions,
                topRight: PlacementPositions,
                bottomLeft: PlacementPositions,
                bottomRight: PlacementPositions,
              },
            },
            mobile: {
              type: "object",
              description:
                "Add padding specific to mobile player placements. Available properties [top, bottom]",
              properties: {
                top: PlacementPositions,
                bottom: PlacementPositions,
              },
            },
          },
        },
      },
      additionalProperties: false,
    },
    publisherName: createSchemaByBasicTypes("string"),
  },
  additionalProperties: false,
};
